import { useFieldArray } from 'react-hook-form';
import { faPlus, faX } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@nazka/nazka.mapframe.components';

import './dynamic-array-input.styl';

function DynamicArrayInput({
  name,
  control,
  label,
  addButtonText = 'Add',
  placeholder = 'Enter value',
  minItems = 0,
  maxItems = 10,
  required = false,
  errors,
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const handleAddItem = () => {
    if (fields.length < maxItems) {
      append('');
    }
  };

  const handleRemoveItem = (index) => {
    if (fields.length > minItems) {
      remove(index);
    }
  };

  return (
    <div className="dynamic-array-input">
      <label className="dynamic-array-input__label">
        {label}
        {' '}
        {required && '*'}
      </label>

      <div className="dynamic-array-input__list">
        {fields.map((field, index) => (
          <>
            <div key={field.id} className="dynamic-array-input__item">
              <input
                type="text"
                {...control.register(`${name}.${index}`, {
                  required: required ? `Step ${index + 1} is required.` : false,
                })}
                className={`dynamic-array-input__input${errors?.[index] ? ' dynamic-array-input__input--error' : ''}`}
                placeholder={`${placeholder} ${index + 1}`}
              />

              {fields.length > minItems && (
                <Button
                  onClick={() => handleRemoveItem(index)}
                  className="dynamic-array-input__item__remove"
                  layout="outlined"
                  icon={faX}
                  color="red"
                />
              )}
            </div>
            {errors?.[index] && <span className="dynamic-array-input__item__error">{errors[index]?.message}</span>}
          </>
        ))}
      </div>

      {fields.length < maxItems && (
        <Button
          onClick={handleAddItem}
          className="dynamic-array-input__add"
          icon={faPlus}
          iconProps={{
            color: 'white',
          }}
        >
          {addButtonText}
        </Button>
      )}

      {fields.length === 0 && minItems === 0 && (
        <p className="dynamic-array-input__empty">
          No items added yet. Click &quot;
          {addButtonText}
          &quot; to get started.
        </p>
      )}
    </div>
  );
}

export default DynamicArrayInput;